import Helper from './Helper';

class HorizontalScroll {
  constructor(config = {}) {
    const {
      containerSelector,
      breakpoint
    } = config;
    this.containers = document.querySelectorAll(containerSelector);
    this.breakpoint = breakpoint || 992;

    this.containersArray = Array.prototype.slice.call(this.containers);
    this.currentScreenWidth = window.innerWidth;
    this.scrollIndicatorClass = "scroll-indicator";

    if(this.containersArray.length > 0){
      this.bindEvents();
    }
  }

  bindEvents(){

    this.isScrollable();

    if (this.currentScreenWidth < this.breakpoint) {
      this.addIndicator();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      if (vw > this.breakpoint) {
        this.removeIndicator();
      } else {
        this.addIndicator();
      }
    });
  }
  
  isScrollable() {
    this.containersArray.forEach((container, i) => {
      Helper.addClass(container, "is-scrollable");
      Helper.addClass(container, "is-scrollable-"+i);
    });
  }

  addIndicator() {
    this.containersArray.forEach((container, i) => {
      Helper.addClass(container, "show-indicator");

      if ( !container.querySelector('.'+this.scrollIndicatorClass) ) {
        let indicator = document.createElement('div');
        Helper.addClass(indicator, this.scrollIndicatorClass);
        container.insertBefore(indicator, container.firstElementChild);

        if ( container.offsetHeight < 200 ) {
          indicator.style.top = '35%'; 
        }
      }

      window.addEventListener("scroll", () => {
        let containerBounding = container.getBoundingClientRect();
        let indicatorElem = container.querySelector('.'+this.scrollIndicatorClass);

        if ( containerBounding.top < 40 && containerBounding.bottom > 150 ) {
          indicatorElem.style.position = 'fixed';
        } else {
          indicatorElem.style.position = null;
        }
      });

      container.addEventListener("scroll", () => {
        this.removeIndicator(container);
      });
    });
  }

  removeIndicator(container) {
    if ( container ) {
      Helper.removeClass(container, "show-indicator");
    } else {
      this.containersArray.forEach((container, i) => {
        Helper.removeClass(container, "show-indicator");
      });
    }
  }

}

export default HorizontalScroll;
